module.exports = __webpack_public_path__ + "static/img/21.1f10f4a3.png";